<div class="{{localService.selectedLanguageCode}}" *ngIf="items">
  <app-popup-header title="{{localService.languageContent.login.enter_as}}"></app-popup-header>
  <div class="styled_row button" *ngFor="let item of items" (click)="onSelect(item.key)">
    <span [ngClass]="localService.getLanguageCode(item.v4)">{{item.v3}}</span>
  </div>
</div>
